import { render, staticRenderFns } from "./Pos_promotion_list.vue?vue&type=template&id=49fe5ba8&scoped=true&"
import script from "./Pos_promotion_list.vue?vue&type=script&lang=js&"
export * from "./Pos_promotion_list.vue?vue&type=script&lang=js&"
import style0 from "./Pos_promotion_list.vue?vue&type=style&index=0&id=49fe5ba8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fe5ba8",
  null
  
)

export default component.exports